import { useLocation, NavLink } from "react-router-dom";
import { IconBuilder } from "/app/src/components/icons/IconBuilder";

/**
 *
 * @param param0 icon, tooltipText and navTo
 * @returns Clickable Nav Item
 */
export default function ClickableNavItem({
  icon,
  navTo,
}: {
  icon: string;
  navTo?: string;
}) {
  const location = useLocation();

  return (
    <div>
      {navTo ? (
        <NavLink
          to={navTo}
          className={`py-3 w-full h-full flex items-center justify-center ${
            location.pathname !== navTo
              ? "hover:bg-primary-muted"
              : "bg-primary-default"
          }`}
        >
          <div className="flex justify-center items-center min-h-full">
            <IconBuilder
              icon={icon}
              color={location.pathname === navTo ? "#ffffff" : "#37464f"}
              size={24}
            />
          </div>
        </NavLink>
      ) : (
        <div className="py-3 w-full h-full flex items-center justify-center">
          <div className="flex justify-center items-center min-h-full">
            <IconBuilder icon={icon} color="#37464f" size={24} />
          </div>
        </div>
      )}
    </div>
  );
}
